module.exports = __webpack_public_path__ + "img/interstitial_6.d42b4971.jpg";